import script from "./PurchasePlan.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchasePlan.vue?vue&type=script&setup=true&lang=js"

import "./PurchasePlan.vue?vue&type=style&index=0&id=26e3b1c9&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26e3b1c9"]])

export default __exports__